import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { Errors } from 'src/infrastructure/labels/errors';
import { Successes } from 'src/infrastructure/labels/successes';
import { Validator } from 'src/infrastructure/validation/validator';
import { ResetPasswordRequestModel } from 'src/models/requestModels/password/resetPasswordRequestModel';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { ToastService } from 'src/services/core/toast/toast.service';
import { UserService } from 'src/services/core/user/user.service';
import { PasswordService } from 'src/services/request/password/password.service';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-accountchangepasswoerd',
  templateUrl: './accountchangepasswoerd.component.html',
  styleUrls: ['./accountchangepasswoerd.component.css']
})
export class AccountchangepasswoerdComponent extends HistoryBaseComponent implements OnInit {

  public resetPasswordsInfo: FormGroup;
  isCapitalLettersCheckValid = true;
  isSmallLettersCheckValid = true;
  isDigitsCheckValid = true;
  isLengthCheckValid = true;
  isSymbolCheckValid = true;

  constructor(
    private FB: FormBuilder,
    private router: Router,
    private passwordService: PasswordService,
    private toastr: ToastService,
    private userService: UserService,
    private localStorageService: LocalstorageService,
    protected location: Location,
    protected historyService: HistoryService

  ) {
    super(location, historyService);
    this._pageTitle = 'resetpassword';
    this.resetPasswordsInfo = FB.group({
      currentPassword: ['', [Validators.required, Validators.minLength(8), Validator.ReactiveFormsValidators.passwordValidator]],
      newPassword: ['', [Validators.required, Validators.minLength(8), Validator.ReactiveFormsValidators.passwordValidator]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8), Validator.ReactiveFormsValidators.passwordValidator]],
    })
  }

  ngOnInit(): void {
  }

  public change() {
    this._error = Validator.FormGroupValidator.validate(this.resetPasswordsInfo);
    if (this._error) {
      this.toastr.error(Errors.bg.invalidFields);
      this._error = '';
      return;
    }
    if (!Validator.InputValidator.password.confirmPasswords(
      this.resetPasswordsInfo.get('newPassword')?.value,
      this.resetPasswordsInfo.get('confirmPassword')?.value
    )) {
      this.toastr.error(Errors.bg.passwordMatch);
      return;
    }
    let resetPasswordRequestModel: ResetPasswordRequestModel = {} as any;
    resetPasswordRequestModel.old_password = this.resetPasswordsInfo.get('currentPassword')?.value;
    resetPasswordRequestModel.password = this.resetPasswordsInfo.get('newPassword')?.value;
    resetPasswordRequestModel.password_confirmation = this.resetPasswordsInfo.get('confirmPassword')?.value;

    this.passwordService.changePassword(resetPasswordRequestModel).subscribe(() => {
      this.toastr.success(Successes.bg.changedPassword);
      this.back();
    });
  }

  public forgottenPassword() {
    this.router.navigate(['password/forgotten']);
  }

  
  checkPassoword(passwordEventTarget: EventTarget | null) {
    if (!passwordEventTarget) return;
    const password = (passwordEventTarget as HTMLInputElement).value;
    this.checkForCapitalLetters(password);
    this.checkForLength(password);
    this.checkForSmallLetters(password);
    this.checkForDigit(password);
    this.checkForSymbol(password);
  }

  checkForCapitalLetters(password: string) {
    this.isCapitalLettersCheckValid = password.search(/[A-ZА-Я]/) >= 0

  }

  checkForLength(password: string) {
    this.isLengthCheckValid = password.length >= 8;
  }

  checkForSmallLetters(password: string) {
    this.isSmallLettersCheckValid = password.search(/[a-zа-я]/) >= 0
  }

  checkForDigit(password: string) {
    this.isDigitsCheckValid = password.search(/\d/) >= 0
  }

  checkForSymbol(password: string) {
    this.isSymbolCheckValid = password.search(/\W/) >= 0
  }

}
